import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "modules/storyblok/adapters/Content";
import config from "config/config";

export const textStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  paragraph: {
    ...contentStyles.paragraph,
    fontSize: "lg",
    color: "primary.900",
  },
};

export const background = {
  bg: "greyscale.200",
  bgImage: {
    base: "none",
    lg: `url(${config.staticUrl}/i/about-us/background-hills.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right bottom",
};
